import { List, ListItem, Typography } from '@mui/material'
import TrombiLink from '../commun/TrombiLink'

export default function Accessibilite() {
  document.title = "Accessibilité | Annuaire de l'Insee"

  return (
    <>
      <br />
      <Typography
        variant="h4"
        component="h2"
        style={{ fontWeight: 'bold' }}
      >
        Déclaration d’accessibilité
      </Typography>
      <Typography
        variant="body1"
        component="p"
      >
        <br />
        L’Insee s’engage à rendre ses sites internet, intranet, extranet et ses progiciels accessibles (et ses
        applications mobiles et mobilier urbain numérique) conformément à l’article 47 de la loi n°2005-102 du 11
        février 2005.
        <br /> À cette fin, L’Insee met en œuvre la stratégie définie dans le{' '}
        <TrombiLink href="https://www.insee.fr/fr/information/7621795">schéma pluriannuel</TrombiLink>
        .
        <br /> Cette déclaration d’accessibilité s’applique à l’
        {''}
        <TrombiLink href="https://trombi.insee.fr/">annuaire des agents de l’Insee.</TrombiLink>
      </Typography>
      <br />
      <Typography
        variant="h6"
        component="h3"
        style={{ fontWeight: 'bold' }}
      >
        État de conformité
      </Typography>
      <Typography
        variant="body1"
        component="p"
      >
        L’annuaire des agents de l’Insee est <b>totalement</b> conforme avec le référentiel général d’amélioration de
        l’accessibilité (RGAA), version 4 suite au contre-audit effectué le 16 septembre 2026 par le Réseau pour
        l’accessibilité numérique de l’Insee (Rani).
      </Typography>
      <br />
      <Typography
        variant="subtitle1"
        component="h4"
        style={{ fontWeight: 'bold' }}
      >
        Résultats des tests
      </Typography>
      <Typography
        variant="body1"
        component="p"
      >
        Le contre-audit de conformité réalisé par le Rani révèle que :
      </Typography>
      <List>
        <ListItem>• 100 % des critères du RGAA version 4 sont respectés ;</ListItem>
      </List>
      <Typography
        variant="body1"
        component="p"
      >
        L’audit fait en avril 2026 avait révélé que 72 % des critères étaient conformes.
      </Typography>
      <br />
      <Typography
        variant="h6"
        component="h3"
        style={{ fontWeight: 'bold' }}
      >
        Contenus non accessibles
      </Typography>
      <br />
      <Typography
        variant="subtitle1"
        component="h4"
        style={{ fontWeight: 'bold' }}
      >
        Non-conformités
      </Typography>
      <Typography
        variant="body1"
        component="p"
      >
        Néant.
      </Typography>
      <br />
      <Typography
        variant="h6"
        component="h3"
        style={{ fontWeight: 'bold' }}
      >
        Établissement de cette déclaration d’accessibilité
      </Typography>
      <Typography
        variant="body1"
        component="p"
      >
        Cette déclaration a été établie le 24/04/2026. Elle a été mise à jour le 16/09/2026.
      </Typography>
      <br />
      <Typography
        variant="subtitle1"
        component="h4"
        style={{ fontWeight: 'bold' }}
      >
        Technologies utilisées pour la réalisation du site
      </Typography>
      <List>
        <ListItem>• HTML5</ListItem>
        <ListItem>• CSS</ListItem>
        <ListItem>• ReactJS</ListItem>
        <ListItem>• Material UI</ListItem>
        <ListItem>• React Router</ListItem>
      </List>
      <br />
      <Typography
        variant="subtitle1"
        component="h4"
        style={{ fontWeight: 'bold' }}
      >
        Environnement de test
      </Typography>
      <Typography
        variant="body1"
        component="p"
      >
        Les vérifications de restitution de contenus ont été réalisées sur la base de la combinaison fournie par la base
        de référence du RGAA, avec les versions suivantes :
      </Typography>
      <List>
        <ListItem>• Firefox et NVDA</ListItem>
      </List>
      <br />
      <Typography
        variant="subtitle1"
        component="h4"
        style={{ fontWeight: 'bold' }}
      >
        Outils pour évaluer l’accessibilité
      </Typography>
      <List>
        <ListItem>• Andi</ListItem>
        <ListItem>• Assistant RGAA</ListItem>
        <ListItem>• Colour contrast analyzer</ListItem>
        <ListItem>• Headingsmap</ListItem>
        <ListItem>• Inspecteur de code</ListItem>
        <ListItem>• Stylus</ListItem>
        <ListItem>• Tanaguru</ListItem>
        <ListItem>• Wave</ListItem>
      </List>
      <br />
      <Typography
        variant="subtitle1"
        component="h4"
        style={{ fontWeight: 'bold' }}
      >
        Pages du site ayant fait l’objet de la vérification de conformité
      </Typography>
      <List>
        <ListItem>
          • page d’accueil :&nbsp;<TrombiLink href="https://trombi.insee.fr/">https://trombi.insee.fr/</TrombiLink>
        </ListItem>
        <ListItem>
          • page contact :&nbsp;
          <TrombiLink href="https://trombi.insee.fr/faq-contact">https://trombi.insee.fr/faq-contact</TrombiLink>
        </ListItem>
        <ListItem>
          • page mentions légales :&nbsp;{''}
          <TrombiLink href="https://trombi.insee.fr/mentions-legales">
            https://trombi.insee.fr/mentions-legales
          </TrombiLink>
        </ListItem>
        <ListItem>
          • page accessibilité :&nbsp;{''}
          <TrombiLink href="https://trombi.insee.fr/accessibilite">https://trombi.insee.fr/accessibilite</TrombiLink>
        </ListItem>
        <ListItem>
          • page sécurité :&nbsp;
          <TrombiLink href="https://trombi.insee.fr/securite ">https://trombi.insee.fr/securite</TrombiLink>
        </ListItem>
      </List>
      <br />
      <Typography
        variant="h6"
        component="h3"
        style={{ fontWeight: 'bold' }}
      >
        Retour d’information et contact
      </Typography>
      <Typography
        variant="body1"
        component="p"
      >
        Si vous n’arrivez pas à accéder à un contenu ou à un service, vous pouvez contacter le responsable pour être
        orienté vers une alternative accessible ou obtenir le contenu sous une autre forme.
      </Typography>
      <List>
        <ListItem>
          • Contacter&nbsp;{''}
          <TrombiLink href="mailto:dg75-sirh@insee.fr?subject=[TROMBI]">
            dg75-sirh@insee.fr, objet "[TROMBI]"
          </TrombiLink>
        </ListItem>
      </List>
      <br />
      <Typography
        variant="h6"
        component="h3"
        style={{ fontWeight: 'bold' }}
      >
        Voies de recours
      </Typography>
      <Typography
        variant="body1"
        component="p"
      >
        Si vous constatez un défaut d’accessibilité vous empêchant d’accéder à un contenu ou une fonctionnalité du site,
        que vous nous le signalez et que vous ne parvenez pas à obtenir une réponse de notre part, vous êtes en droit de
        faire parvenir vos doléances ou une demande de saisine au Défenseur des droits.
        <br />
        <br />
        Plusieurs moyens sont à votre disposition :
      </Typography>
      <List>
        <ListItem>
          •&nbsp;{''}
          <TrombiLink href="https://formulaire.defenseurdesdroits.fr/formulaire_saisine/?ETAPE=accueil_2016">
            Écrire un message au Défenseur des droits
          </TrombiLink>
        </ListItem>
        <ListItem>
          •&nbsp;{''}
          <TrombiLink href="https://www.defenseurdesdroits.fr/carte-des-delegues">
            Contacter le délégué du Défenseur des droits dans votre région
          </TrombiLink>
        </ListItem>
        <ListItem>
          • Envoyer un courrier par la poste (gratuit, ne pas mettre de timbre) :
          <br />
          Défenseur des droits
          <br />
          Libre réponse 71120
          <br />
          75342 Paris CEDEX 07
        </ListItem>
      </List>

      <br />
      <Typography
        variant="h4"
        component="h2"
        style={{ fontWeight: 'bold' }}
      >
        Naviguer au clavier
      </Typography>
      <List>
        <ListItem>
          • La navigation au clavier sur l'annuaire est permise par l'utilisation des touches directionnelles, des
          touches Tabulation, Shift, Entrée, et de la barre Espace.
        </ListItem>
        <ListItem>
          • Pour naviguer entre les différents éléments de l'annuaire, utilisez la touche Tabulation pour sélectionner
          l'élément suivant, ou Tab + Shift pour sélectionner l'élément précédent. Si une unité est sélectionnée et des
          agents affichés, cette manipulation permettra de passer d'un agent à un autre.
        </ListItem>
        <ListItem>
          • Si l'arbre des unités est sélectionné, les flèches directionnelles Haut et Bas vous permettent de naviguer
          de haut en bas dans l'arbre. La barre Espace permet de déplier (ou replier) le sous-arbre des sous-unités
          d'une unité s'il y en a et d'afficher les agents affectés sur cette unité. Pour sortir de l'arbre des unités,
          la touche Tabulation permet de passer à l'élément suivant.
        </ListItem>
        <ListItem>
          • Dans les champs de recherche, les échos s'actualisent automatiquement à chaque saisie d'un nouveau
          caractère. La navigation parmis ces réponses se fait par les flèches directionnelles Haut et Bas, la
          validation par la touche Entrée.
        </ListItem>
      </List>
    </>
  )
}
